// ===========================================
// PWAInstallPrompt.js
// 童顏家行程日曆系統 - PWA 安裝提示元件
//
// 版本：V1.01 | 2024-07-05 20:00:00
// 主要功能：顯示 PWA 安裝提示，協助用戶安裝應用程式
// 解決問題：引導用戶將應用程式安裝到主畫面，提升體驗
//
// 版本紀錄：
// - V1.01 (2024-07-05): 初始版本，從 App.js 拆分
//
// 注意事項：
// - 僅負責顯示與互動，不處理安裝邏輯
// - 關聯檔案：App.js
// ===========================================
import React from 'react';

const PWAInstallPrompt = ({ onInstall, onClose }) => {
    return (
        <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-blue-500 to-purple-600 text-white p-4 shadow-lg z-50 transform transition-all duration-500 ease-out">
            <div className="max-w-4xl mx-auto flex items-center justify-between">
                <div className="flex items-center space-x-3">
                    <div className="bg-white p-2 rounded-lg">
                        <img 
                            src="/images/tyj-app-logo.png" 
                            alt="童顏家 Logo" 
                            className="w-8 h-8 object-contain"
                        />
                    </div>
                    <div>
                        <h3 className="font-bold text-lg">安裝童顏家行程日曆</h3>
                        <p className="text-sm opacity-90">將應用程式加到主畫面，享受更佳的使用體驗</p>
                    </div>
                </div>
                <div className="flex items-center space-x-2">
                    <button 
                        onClick={onInstall}
                        className="bg-white text-blue-600 font-bold px-4 py-2 rounded-lg hover:bg-gray-100 transition-colors"
                    >
                        安裝
                    </button>
                    <button 
                        onClick={onClose}
                        className="text-white hover:text-gray-200 transition-colors text-xl ml-2"
                        aria-label="關閉"
                    >
                        ✕
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PWAInstallPrompt; 